import WouldUrideTaolaReservationComplete from '../views/taola/wouldUride/WouldUrideTaolaReservationComplete.vue'
import WouldUrideTaolaEvent from '../views/taola/wouldUride/WouldUrideTaolaEvent.vue'

export default [
  {
    path: '/wouldu-event',
    name: 'wouldu-event',
    component: WouldUrideTaolaEvent
  },
  
  {
    path: '/wouldu-complete',
    name: 'wouldu-complete',
    component: WouldUrideTaolaReservationComplete
  },
    // {
    //   path: '/survey/CM/:wave_number',
    //   name: 'chiangmai-survey',
    //   component: Survey2
    // },
]


// WEBPACK FOOTER //
// ./src/router/taola.js